export const promptSuggestionsCategories = [
  {
    name: 'Tax & Currency',
    icon: 'currencyDollar',
    prompts: [
      {
        id: 'tc_001',
        prompt: 'Validate currency is in allowed list for this entity',
      },
      {
        id: 'tc_002',
        prompt:
          'Match tax code by country and rate percentage, since same rate might have different codes per jurisdiction',
      },
      {
        id: 'tc_003',
        prompt:
          'Determine applicable tax based on sender country, recipient country, and transaction type (goods/services)',
      },
    ],
  },
  {
    name: 'Address & Location',
    icon: 'mapPin',
    prompts: [
      {
        id: 'al_001',
        prompt: 'Address verification (follow best practices)',
      },
      {
        id: 'al_002',
        prompt:
          'Parse sender_address into structured components (street, city, postal, country), then match each component',
      },
      {
        id: 'al_003',
        prompt:
          'Match location by postal code, but if postal format invalid for country, fall back to city + street',
      },
      {
        id: 'al_004',
        prompt:
          'Fuzzy match city name, but boost score if country matches exactly',
      },
      {
        id: 'al_005',
        prompt:
          'Match address and enrich with missing fields: if only postal code provided, add city and country from master',
      },
    ],
  },
  {
    name: 'Company & Entity',
    icon: 'buildingBank',
    prompts: [
      {
        id: 'ce_001',
        prompt: 'Company matching (best practices)',
      },
      {
        id: 'ce_002',
        prompt:
          'Match company, but if recipient_vat_id is empty, use recipient_name and recipient_address only',
      },
      {
        id: 'ce_003',
        prompt:
          'Match recipient company to legal entity master, return all subsidiaries if holding company matched',
      },
      {
        id: 'ce_004',
        prompt:
          'Match by VAT and name, but exclude entities where country_code != invoice currency first two letters',
      },
      {
        id: 'ce_005',
        prompt:
          'Match company across multiple datasets: try primary entities first, then archived entities if nothing found',
      },
    ],
  },
  {
    name: 'Payment Terms',
    icon: 'clipboardText',
    prompts: [
      {
        id: 'pt_001',
        prompt: 'Payment terms matching (follow best practices)',
      },
      {
        id: 'pt_002',
        prompt:
          'Match payment terms, calculate actual due date from invoice date + terms days, return as new field',
      },
      {
        id: 'pt_003',
        prompt:
          'If payment terms field is empty, infer from vendor master default terms',
      },
      {
        id: 'pt_004',
        prompt:
          "Match Incoterms and validate: if 'DDP' then recipient country must match ship-to country",
      },
      {
        id: 'pt_005',
        prompt:
          'Try matching terms code, if multiple matches found return the one most frequently used by this vendor',
      },
    ],
  },
  {
    name: 'Vendor Matching',
    icon: 'buildingStore',
    prompts: [
      {
        id: 'vm_001',
        prompt: 'Vendor matching (follow best practices)',
      },
      {
        id: 'vm_002',
        prompt:
          'Match vendors but prioritize VAT ID over name - only consider name if VAT match is ambiguous',
      },
      {
        id: 'vm_003',
        prompt:
          "Match sender_vat_id field to VAT_Number in dataset, but only return vendors with dataset column active=true and approved_status='APPROVED'",
      },
      {
        id: 'vm_004',
        prompt:
          'Match vendors by email domain first, then by company name if no email available',
      },
      {
        id: 'vm_005',
        prompt:
          'Fuzzy match on vendor name and address, but require exact postal code match within the address',
      },
    ],
  },
  {
    name: 'Product & Items',
    icon: 'tag',
    prompts: [
      {
        id: 'pi_001',
        prompt: 'Product matching (best practices)',
      },
      {
        id: 'pi_002',
        prompt:
          "Match item code, but if it starts with 'TEMP-' or 'TMP-', skip code matching and use description only",
      },
      {
        id: 'pi_003',
        prompt:
          'Match product by customer-specific catalog for this B2B unit, fall back to universal catalog if not found',
      },
      {
        id: 'pi_004',
        prompt:
          'Match item_code to multiple product code fields (SKU, Manufacturer_Code, Customer_Code) and return first match',
      },
      {
        id: 'pi_005',
        prompt:
          'Match products and filter: only return items where unit_price in dataset is within 10% of invoice line unit price',
      },
    ],
  },

  {
    name: 'Units & Classification',
    icon: 'ruler2',
    prompts: [
      {
        id: 'uc_001',
        prompt: 'UOM validation (best practices)',
      },
      {
        id: 'uc_002',
        prompt:
          'Match UOM and return conversion factor to base unit (e.g., if BOX convert to EA using pack size)',
      },
      {
        id: 'uc_003',
        prompt:
          'Validate HS code length: if 6 digits provided, expand to 10 digits using country-specific defaults',
      },
      {
        id: 'uc_004',
        prompt:
          "Match UOM but allow aliases: 'Dozen', 'DZ', 'DOZ' should all match to same unit",
      },
      {
        id: 'uc_005',
        prompt:
          'Classify HS code: if full code not provided, predict from product description using existing mappings',
      },
    ],
  },

  {
    name: 'Purchase Orders',
    icon: 'package',
    prompts: [
      {
        id: 'po_001',
        prompt: 'PO matching (follow best practices)',
      },
      {
        id: 'po_002',
        prompt:
          "Match order_id to PO_Number, but only return POs where status is 'OPEN' or 'PARTIALLY_RECEIVED'",
      },
      {
        id: 'po_003',
        prompt:
          "Try matching full PO number, if not found check if it's a line reference format (PO-LineNum) and extract just PO part",
      },
      {
        id: 'po_004',
        prompt:
          'Match PO header by number, then validate line items: sum(PO line quantities) should match invoice line count',
      },
      {
        id: 'po_005',
        prompt:
          'Match PO and if found, pull vendor data from PO rather than from invoice to ensure consistency',
      },
    ],
  },
] as const;
